import {
    isFirefox,
    isChrome,
    isSafari,
    isEdge,
    isChromium,
} from 'react-device-detect';
import BaseConfig from 'config/base-config.json';
import {useMemo} from 'react';

export enum BROWSERS {
    FIREFOX = 'firefox',
    CHROME = 'chrome',
    CHROMIUM = 'chromium',
    SAFARI = 'safari',
    EDGE = 'edge',
}

export const useCheckBrowsers = () => {
    const showDragHandle = useMemo(() => {
        const jobDashboardDragHandle =
            BaseConfig.USER_CUSTOMER.jobDashboardDragHandle;

        // Determine if the current browser is listed in the jobDashboardDragHandle array
        return jobDashboardDragHandle.some((browser) => {
            switch (browser) {
                case BROWSERS.FIREFOX:
                    return isFirefox;
                case BROWSERS.CHROME:
                    return isChrome;
                case BROWSERS.CHROMIUM:
                    return isChromium;
                case BROWSERS.SAFARI:
                    return isSafari;
                case BROWSERS.EDGE:
                    return isEdge;
                default:
                    return false;
            }
        });
    }, []);

    return {
        showDragHandle,
    };
};
